import { Router } from "easy-page-router/react";

import Index from "./pages/Index";
import Events from "./pages/Events";
import AboutUs from "./pages/AboutUs";
import Projects from "./pages/Projects";
import Project from "./pages/Project";
import DepartmentsAndSocieties from "./pages/DepartmentsAndSocieties";
import Gallery from "./pages/Gallery";
import Documents from "./pages/Documents";
import Accommodations from "./pages/Accommodations";
import Contact from "./pages/Contact";

import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";

export default function TSORouter() {
    return <Router
        renderAnimation={({ page, state }) => state === "active" && <div className="page">{page}</div>}
        renderPage={({ path }) => {
            if (path.length === 0) return <Index />;

            if (path[0] === "akce") return <Events />;
            if (path[0] === "o-nas") return <AboutUs />;
            if (path[0] === "projekty") return <Projects />;
            if (path[0] === "projekt" && path[1]) return <Project id={path[1]} />;
            if (path[0] === "oddily-a-spolky") return <DepartmentsAndSocieties />;
            if (path[0] === "fotogalerie") return <Gallery />;
            if (path[0] === "dokumenty") return <Documents />;
            if (path[0] === "ubytovani") return <Accommodations />;
            if (path[0] === "kontakt") return <Contact />;

            if (path[0] === "admin") return <Admin />;

            return <NotFound />;
        }}
    />;
}
